import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const COLORES_NIVEL = {
  A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6',
  B2:'#F59E0B', C1:'#EF4444', C2:'#1B3A8C'
}

const DIAS = ['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado']
const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
const DIAS_EN = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
const MESES_EN = ['January','February','March','April','May','June','July','August','September','October','November','December']

function formatFecha(fechaStr, idioma = 'es') {
  const d = new Date(fechaStr + 'T00:00:00')
  if (idioma === 'en') return DIAS_EN[d.getDay()] + ', ' + MESES_EN[d.getMonth()] + ' ' + d.getDate()
  return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()]
}

const TX = {
  es: {
    libre: 'Clase libre - cualquier estudiante puede unirse', reqTitulo: 'Requisitos para inscribirse',
    nivelMinReq: 'Nivel minimo requerido:', lecturaPrevia: 'Lectura previa:', profNativo: 'Profesor nativo', cerrar: 'Cerrar',
    errInscribir: 'Error al inscribirse', inscCancelada: 'Inscripcion cancelada', errCancelar: 'Error al cancelar',
    cargando: 'Cargando clases...', volver: '← Volver a clases', grupal: 'Clase grupal', privada: 'Clase privada', inscrito: 'Inscrito',
    horario: 'Horario', duracion: 'Duracion:', minutos: 'minutos', profesor: 'Profesor', verPerfilFlecha: 'Ver perfil →',
    tema: 'Tema', cupos: 'Cupos', deDisponibles: 'disponibles', entrarSala: '🎥 Entrar a la sala de clase',
    cancelarInsc: 'Cancelar inscripcion', procesando: 'Procesando...', sinCuposLargo: 'Sin cupos disponibles',
    inscribirmeEsta: 'Inscribirme a esta clase', titulo: 'Clases en vivo',
    subtitulo: 'Clases grupales con profesores nativos. Maximo 8 estudiantes por clase.',
    b1: 'Max. 8 estudiantes', b2: 'Tema definido', b3: 'Profesor nativo', b4: 'Algunos con requisitos',
    todosNiveles: 'Todos los niveles', clase: 'clase', clases: 'clases', requisitos: 'Requisitos', temaDos: 'Tema:',
    nivelMin: 'Nivel minimo:', lecturaReq: ' · Lectura previa requerida', verPerfil: 'Ver perfil', de: 'de',
    verDetalles: 'Ver detalles', entrar: '🎥 Entrar', cancelar: 'Cancelar', sinCupos: 'Sin cupos', inscribirme: 'Inscribirme',
    vacio: 'No hay clases disponibles para este nivel.'
  },
  en: {
    libre: 'Open class - any student can join', reqTitulo: 'Requirements to enroll',
    nivelMinReq: 'Minimum level required:', lecturaPrevia: 'Prior reading:', profNativo: 'Native teacher', cerrar: 'Close',
    errInscribir: 'Could not enroll', inscCancelada: 'Enrollment cancelled', errCancelar: 'Could not cancel',
    cargando: 'Loading classes...', volver: '← Back to classes', grupal: 'Group class', privada: 'Private class', inscrito: 'Enrolled',
    horario: 'Schedule', duracion: 'Duration:', minutos: 'minutes', profesor: 'Teacher', verPerfilFlecha: 'View profile →',
    tema: 'Topic', cupos: 'Spots', deDisponibles: 'available', entrarSala: '🎥 Enter the class room',
    cancelarInsc: 'Cancel enrollment', procesando: 'Processing...', sinCuposLargo: 'No spots available',
    inscribirmeEsta: 'Enroll in this class', titulo: 'Live classes',
    subtitulo: 'Group classes with native teachers. Maximum 8 students per class.',
    b1: 'Max. 8 students', b2: 'Set topic', b3: 'Native teacher', b4: 'Some have requirements',
    todosNiveles: 'All levels', clase: 'class', clases: 'classes', requisitos: 'Requirements', temaDos: 'Topic:',
    nivelMin: 'Minimum level:', lecturaReq: ' · Prior reading required', verPerfil: 'View profile', de: 'of',
    verDetalles: 'View details', entrar: '🎥 Enter', cancelar: 'Cancel', sinCupos: 'Full', inscribirme: 'Enroll',
    vacio: 'There are no classes available for this level.'
  }
}

function formatHora(horaStr) {
  const [h, m] = horaStr.split(':')
  const hora = parseInt(h)
  const ampm = hora >= 12 ? 'PM' : 'AM'
  const h12 = hora % 12 || 12
  return h12 + ':' + m + ' ' + ampm
}

function BadgeNivel({ nivel }) {
  if (!nivel) return null
  return (
    <span style={{ background: COLORES_NIVEL[nivel] || '#6B7280', color:'#fff', fontSize:10, fontWeight:800, padding:'2px 8px', borderRadius:999 }}>
      {nivel}
    </span>
  )
}

function RequisitosCard({ requisitos, nivelUsuario, t }) {
  if (!requisitos || requisitos.libre) return (
    <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'#22C55E', fontWeight:600 }}>
      <span>✅</span> {t.libre}
    </div>
  )

  const niveles = ['A1','A2','B1','B2','C1','C2']
  const nivelMin = requisitos.nivel_minimo
  const cumpleNivel = !nivelMin || niveles.indexOf(nivelUsuario) >= niveles.indexOf(nivelMin)

  return (
    <div style={{ background:'#FEF9C3', border:'1px solid #F59E0B', borderRadius:8, padding:'10px 12px' }}>
      <div style={{ fontSize:12, fontWeight:700, color:'#854D0E', marginBottom:6 }}>{t.reqTitulo}</div>
      {nivelMin && (
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, marginBottom:4,
          color: cumpleNivel ? '#166534' : '#991B1B' }}>
          <span>{cumpleNivel ? '✅' : '❌'}</span>
          {t.nivelMinReq} <BadgeNivel nivel={nivelMin} />
        </div>
      )}
      {requisitos.lectura_previa && (
        <div style={{ display:'flex', alignItems:'flex-start', gap:6, fontSize:12, color:'#854D0E' }}>
          <span>📖</span>
          <span>{t.lecturaPrevia} {requisitos.lectura_previa}</span>
        </div>
      )}
    </div>
  )
}

// Perfil completo del profesor -- se abre al hacer click en su foto/nombre.
// Usa los campos profesor_* que ya vienen aplanados en cada clase (ver
// GET /curriculo/clases en el backend).
function ModalPerfilProfesor({ clase, onCerrar, t }) {
  if (!clase) return null
  return (
    <div onClick={onCerrar} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:'#fff', borderRadius:16, padding:28, maxWidth:380, width:'100%', textAlign:'center' }}>
        <div style={{ width:96, height:96, borderRadius:'50%', background:'#E8EFFE', margin:'0 auto 16px', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', fontSize:44 }}>
          {clase.profesor_foto
            ? <img src={clase.profesor_foto} alt={clase.profesor_nombre} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
            : '👤'}
        </div>
        <div style={{ fontSize:18, fontWeight:800, color:'#1A1A2E', marginBottom:4 }}>{clase.profesor_nombre}</div>
        <div style={{ fontSize:12, color:'#6B7280', marginBottom:12 }}>{t.profNativo}</div>
        {clase.profesor_bio && (
          <p style={{ fontSize:13, color:'#374151', lineHeight:1.6, textAlign:'left' }}>{clase.profesor_bio}</p>
        )}
        <button onClick={onCerrar} style={{ marginTop:16, padding:'9px 24px', borderRadius:10, border:'1.5px solid #E2E6F0', background:'#fff', color:'#374151', fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer' }}>
          {t.cerrar}
        </button>
      </div>
    </div>
  )
}

export default function ClasesVivo({ usuario, onUnirse, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const fecha_ = f => formatFecha(f, idioma)
  const [clases,      setClases]      = useState([])
  const [inscritas,   setInscritas]   = useState([])
  const [cargando,    setCargando]    = useState(true)
  const [procesando,  setProcesando]  = useState(null)
  const [mensaje,     setMensaje]     = useState(null)
  const [filtroNivel, setFiltroNivel] = useState('todos')
  const [claseDetalle, setClaseDetalle] = useState(null)
  const [perfilProfesor, setPerfilProfesor] = useState(null) // clase cuyo profesor se esta viendo en el modal

  useEffect(() => { cargarDatos() }, [usuario])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [clasesRes, inscritasRes] = await Promise.all([
        axios.get(API + '/curriculo/clases'),
        usuario
          ? axios.get(API + '/curriculo/clases/mis-inscripciones/' + usuario.id).catch(() => ({ data: { datos: [] } }))
          : Promise.resolve({ data: { datos: [] } })
      ])
      setClases(clasesRes.data.datos || [])
      setInscritas(inscritasRes.data.datos || [])
    } catch (err) { console.error(err) }
    finally { setCargando(false) }
  }

  async function inscribirse(claseId) {
    if (!usuario) return
    setProcesando(claseId)
    try {
      const res = await axios.post(API + '/curriculo/clases/' + claseId + '/inscribir', { usuario_id: usuario.id })
      setInscritas(prev => [...prev, claseId])
      setMensaje({ tipo:'ok', texto: res.data.mensaje })
      setTimeout(() => setMensaje(null), 4000)
      cargarDatos()
    } catch (err) {
      setMensaje({ tipo:'error', texto: err.response?.data?.error || t.errInscribir })
      setTimeout(() => setMensaje(null), 4000)
    } finally { setProcesando(null) }
  }

  async function cancelar(claseId) {
    if (!usuario) return
    setProcesando(claseId)
    try {
      await axios.delete(API + '/curriculo/clases/' + claseId + '/cancelar', { data: { usuario_id: usuario.id } })
      setInscritas(prev => prev.filter(id => id !== claseId))
      setMensaje({ tipo:'ok', texto: t.inscCancelada })
      setTimeout(() => setMensaje(null), 3000)
      cargarDatos()
    } catch (err) {
      setMensaje({ tipo:'error', texto: t.errCancelar })
      setTimeout(() => setMensaje(null), 3000)
    } finally { setProcesando(null) }
  }

  const niveles = ['todos', ...new Set(clases.map(c => c.nivel_id).filter(Boolean))]
  const clasesFiltradas = filtroNivel === 'todos' ? clases : clases.filter(c => c.nivel_id === filtroNivel)
  const porFecha = clasesFiltradas.reduce((acc, c) => {
    if (!acc[c.fecha]) acc[c.fecha] = []
    acc[c.fecha].push(c)
    return acc
  }, {})

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:60, gap:16, color:'#6B7280' }}>
      <div style={{ width:32, height:32, border:'3px solid #E2E6F0', borderTopColor:'#1B3A8C', borderRadius:'50%', animation:'spinner .8s linear infinite' }} />
      {t.cargando}
    </div>
  )

  // Modal detalle de clase
  if (claseDetalle) {
    const clase = claseDetalle
    const estaInscrito = inscritas.includes(clase.id)
    const sinCupos = clase.cupos_disponibles <= 0
    const req = clase.requisitos || { libre: true }

    return (
      <div style={{ maxWidth:700, margin:'0 auto', animation:'fadeIn .3s ease both' }}>
        <button onClick={() => setClaseDetalle(null)}
          style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit', marginBottom:20 }}>
          {t.volver}
        </button>

        <div style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius:16, padding:28, color:'#fff', marginBottom:24 }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
            <BadgeNivel nivel={clase.nivel_id} />
            <span style={{ fontSize:12, background:'rgba(255,255,255,0.15)', padding:'2px 10px', borderRadius:999 }}>
              {clase.tipo === 'grupal' ? t.grupal : t.privada}
            </span>
            {estaInscrito && <span style={{ fontSize:12, background:'#22C55E', padding:'2px 10px', borderRadius:999 }}>{t.inscrito}</span>}
          </div>
          <h1 style={{ fontSize:22, fontWeight:800, marginBottom:8 }}>{clase.nombre}</h1>
          <p style={{ fontSize:14, opacity:.85, lineHeight:1.6 }}>{clase.descripcion}</p>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 }}>
          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.horario}</div>
            <div style={{ fontSize:20, fontWeight:800, color:'#1B3A8C' }}>{formatHora(clase.hora_inicio)}</div>
            <div style={{ fontSize:13, color:'#6B7280' }}>{fecha_(clase.fecha)}</div>
            <div style={{ fontSize:12, color:'#9CA3AF', marginTop:4 }}>
              {t.duracion} {clase.duracion_min || 60} {t.minutos}
            </div>
          </div>

          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.profesor}</div>
            <button onClick={() => setPerfilProfesor(clase)}
              style={{ display:'flex', alignItems:'center', gap:10, background:'none', border:'none', padding:0, cursor:'pointer', textAlign:'left' }}>
              <div style={{ width:40, height:40, borderRadius:'50%', background:'#E8EFFE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, overflow:'hidden', flexShrink:0 }}>
                {clase.profesor_foto
                  ? <img src={clase.profesor_foto} alt={clase.profesor_nombre} style={{ width:40, height:40, borderRadius:'50%', objectFit:'cover' }} />
                  : '👤'}
              </div>
              <div>
                <div style={{ fontSize:14, fontWeight:700, color:'#1A1A2E' }}>{clase.profesor_nombre}</div>
                <div style={{ fontSize:12, color:'#6B7280' }}>{t.verPerfilFlecha}</div>
              </div>
            </button>
          </div>

          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.tema}</div>
            <div style={{ fontSize:14, color:'#374151', lineHeight:1.5 }}>{clase.tema || clase.nombre}</div>
          </div>

          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.cupos}</div>
            <div style={{ fontSize:28, fontWeight:800, color: sinCupos ? '#EF4444' : clase.cupos_disponibles <= 3 ? '#F59E0B' : '#22C55E' }}>
              {clase.cupos_disponibles}
            </div>
            <div style={{ fontSize:12, color:'#6B7280' }}>{t.de} {clase.cupos_total} {t.deDisponibles}</div>
            <div style={{ height:6, background:'#E2E6F0', borderRadius:999, marginTop:8, overflow:'hidden' }}>
              <div style={{ width: (clase.cupos_ocupados / clase.cupos_total * 100) + '%', height:'100%', borderRadius:999,
                background: sinCupos ? '#EF4444' : clase.cupos_disponibles <= 3 ? '#F59E0B' : '#22C55E' }} />
            </div>
          </div>
        </div>

        <div style={{ marginBottom:20 }}>
          <RequisitosCard requisitos={req} nivelUsuario={null} t={t} />
        </div>

        {mensaje && (
          <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:14, fontWeight:600,
            background: mensaje.tipo==='ok' ? '#F0FDF4' : '#FEF2F2',
            color: mensaje.tipo==='ok' ? '#166534' : '#991B1B',
            border:'1px solid ' + (mensaje.tipo==='ok' ? '#22C55E' : '#EF4444') }}>
            {mensaje.tipo==='ok' ? '✅' : '❌'} {mensaje.texto}
          </div>
        )}

        <div style={{ display:'flex', gap:12 }}>
          {estaInscrito ? (
            <>
              <button onClick={() => onUnirse && onUnirse(clase.id)}
                style={{ flex:1, padding:'12px', background:'#1B3A8C', color:'#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer', textAlign:'center' }}>
                {t.entrarSala}
              </button>
              <button onClick={() => cancelar(clase.id)} disabled={procesando === clase.id}
                style={{ padding:'12px 20px', background:'#FEF2F2', color:'#EF4444', border:'1.5px solid #EF4444', borderRadius:12, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                {t.cancelarInsc}
              </button>
            </>
          ) : (
            <button onClick={() => inscribirse(clase.id)} disabled={sinCupos || procesando === clase.id}
              style={{ flex:1, padding:'12px', background: sinCupos ? '#E2E6F0' : '#1B3A8C', color: sinCupos ? '#9CA3AF' : '#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:15, fontWeight:700, cursor: sinCupos ? 'not-allowed' : 'pointer' }}>
              {procesando === clase.id ? t.procesando : sinCupos ? t.sinCuposLargo : t.inscribirmeEsta}
            </button>
          )}
        </div>

        <ModalPerfilProfesor clase={perfilProfesor} onCerrar={() => setPerfilProfesor(null)} t={t} />
      </div>
    )
  }

  return (
    <div style={{ maxWidth:900, margin:'0 auto', animation:'fadeIn .3s ease both' }}>

      <div style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius:16, padding:24, marginBottom:24, color:'#fff' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
          <span style={{ fontSize:32 }}>🎥</span>
          <div>
            <h1 style={{ fontSize:22, fontWeight:800, marginBottom:2 }}>{t.titulo}</h1>
            <p style={{ fontSize:13, opacity:.8 }}>{t.subtitulo}</p>
          </div>
        </div>
        <div style={{ display:'flex', gap:20, flexWrap:'wrap' }}>
          {[
            { ic:'👥', label:t.b1 },
            { ic:'🎯', label:t.b2 },
            { ic:'👨‍🏫', label:t.b3 },
            { ic:'📋', label:t.b4 },
          ].map((item,i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, opacity:.85 }}>
              <span>{item.ic}</span><span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {mensaje && (
        <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:14, fontWeight:600,
          background: mensaje.tipo==='ok' ? '#F0FDF4' : '#FEF2F2',
          color: mensaje.tipo==='ok' ? '#166534' : '#991B1B',
          border:'1px solid ' + (mensaje.tipo==='ok' ? '#22C55E' : '#EF4444') }}>
          {mensaje.tipo==='ok' ? '✅' : '❌'} {mensaje.texto}
        </div>
      )}

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {niveles.map(n => (
          <button key={n} onClick={() => setFiltroNivel(n)}
            style={{ padding:'6px 16px', borderRadius:999, border:'2px solid ' + (filtroNivel===n ? (COLORES_NIVEL[n]||'#1B3A8C') : '#E2E6F0'),
              background: filtroNivel===n ? (COLORES_NIVEL[n]||'#1B3A8C') : '#fff',
              color: filtroNivel===n ? '#fff' : '#374151',
              fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
            {n === 'todos' ? t.todosNiveles : n}
          </button>
        ))}
      </div>

      {Object.keys(porFecha).sort().map(fecha => (
        <div key={fecha} style={{ marginBottom:28 }}>
          <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
            <div style={{ background:'#1B3A8C', color:'#fff', borderRadius:10, padding:'6px 14px', fontSize:13, fontWeight:700 }}>
              📅 {fecha_(fecha)}
            </div>
            <div style={{ flex:1, height:1, background:'#E2E6F0' }} />
            <span style={{ fontSize:12, color:'#6B7280' }}>{porFecha[fecha].length} {porFecha[fecha].length>1 ? t.clases : t.clase}</span>
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {porFecha[fecha].map(clase => {
              const estaInscrito = inscritas.includes(clase.id)
              const sinCupos = clase.cupos_disponibles <= 0
              const cargandoEsta = procesando === clase.id
              const req = clase.requisitos || { libre: true }
              const tieneRequisitos = !req.libre

              return (
                <div key={clase.id}
                  style={{ background:'#fff', border:'1.5px solid ' + (estaInscrito ? '#22C55E' : '#E2E6F0'),
                    borderRadius:14, padding:'18px 20px',
                    boxShadow: estaInscrito ? '0 0 0 3px rgba(34,197,94,0.1)' : 'none' }}>

                  <div style={{ display:'flex', alignItems:'flex-start', gap:16, flexWrap:'wrap' }}>

                    <div style={{ textAlign:'center', minWidth:70 }}>
                      <div style={{ fontSize:18, fontWeight:800, color:'#1B3A8C' }}>{formatHora(clase.hora_inicio)}</div>
                      <div style={{ fontSize:11, color:'#6B7280' }}>{formatHora(clase.hora_fin)}</div>
                      <div style={{ fontSize:11, color:'#9CA3AF', marginTop:2 }}>{clase.duracion_min || 60} min</div>
                    </div>

                    <div style={{ width:1, height:60, background:'#E2E6F0', flexShrink:0 }} />

                    <div style={{ flex:1, minWidth:200 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, flexWrap:'wrap' }}>
                        <BadgeNivel nivel={clase.nivel_id} />
                        {tieneRequisitos && (
                          <span style={{ fontSize:10, background:'#FEF9C3', color:'#854D0E', padding:'2px 8px', borderRadius:999, fontWeight:700 }}>
                            {t.requisitos}
                          </span>
                        )}
                        {estaInscrito && <span style={{ fontSize:11, color:'#22C55E', fontWeight:700 }}>{t.inscrito}</span>}
                      </div>
                      <div style={{ fontSize:15, fontWeight:700, color:'#1A1A2E', marginBottom:4 }}>{clase.nombre}</div>
                      {clase.tema && <div style={{ fontSize:12, color:'#7C3AED', fontWeight:600, marginBottom:4 }}>{t.temaDos} {clase.tema}</div>}
                      {clase.descripcion && <div style={{ fontSize:12, color:'#6B7280', marginBottom:8 }}>{clase.descripcion}</div>}

                      {tieneRequisitos && (
                        <div style={{ fontSize:11, color:'#854D0E', background:'#FEF9C3', padding:'4px 8px', borderRadius:6, display:'inline-block' }}>
                          {req.nivel_minimo && t.nivelMin + ' ' + req.nivel_minimo}
                          {req.lectura_previa && t.lecturaReq}
                        </div>
                      )}
                    </div>

                    <button onClick={() => setPerfilProfesor(clase)}
                      style={{ textAlign:'center', minWidth:110, background:'none', border:'none', cursor:'pointer', fontFamily:'inherit' }}>
                      <div style={{ width:40, height:40, borderRadius:'50%', background:'#E8EFFE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, margin:'0 auto 4px', overflow:'hidden' }}>
                        {clase.profesor_foto
                          ? <img src={clase.profesor_foto} alt={clase.profesor_nombre} style={{ width:40, height:40, borderRadius:'50%', objectFit:'cover' }} />
                          : '👤'}
                      </div>
                      <div style={{ fontSize:12, fontWeight:600, color:'#1A1A2E' }}>{clase.profesor_nombre}</div>
                      <div style={{ fontSize:11, color:'#6B7280' }}>{t.verPerfil}</div>
                    </button>

                    <div style={{ textAlign:'center', minWidth:70 }}>
                      <div style={{ fontSize:22, fontWeight:800, color: sinCupos ? '#EF4444' : clase.cupos_disponibles <= 2 ? '#F59E0B' : '#22C55E' }}>
                        {clase.cupos_disponibles}
                      </div>
                      <div style={{ fontSize:11, color:'#6B7280' }}>{t.de} {clase.cupos_total}</div>
                      <div style={{ width:50, height:4, background:'#E2E6F0', borderRadius:999, margin:'4px auto 0', overflow:'hidden' }}>
                        <div style={{ width: (clase.cupos_ocupados/clase.cupos_total*100) + '%', height:'100%', borderRadius:999,
                          background: sinCupos ? '#EF4444' : clase.cupos_disponibles <= 2 ? '#F59E0B' : '#22C55E' }} />
                      </div>
                    </div>

                    <div style={{ minWidth:130, display:'flex', flexDirection:'column', gap:6 }}>
                      <button onClick={() => setClaseDetalle(clase)}
                        style={{ width:'100%', padding:'7px 0', background:'#F4F6FA', color:'#1B3A8C', border:'1px solid #E2E6F0', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                        {t.verDetalles}
                      </button>
                      {estaInscrito ? (
                        <>
                          <button onClick={() => onUnirse && onUnirse(clase.id)}
                            style={{ width:'100%', padding:'7px 0', background:'#1B3A8C', color:'#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:700, cursor:'pointer' }}>
                            {t.entrar}
                          </button>
                          <button onClick={() => cancelar(clase.id)} disabled={cargandoEsta}
                            style={{ width:'100%', padding:'7px 0', background:'#FEF2F2', color:'#EF4444', border:'1.5px solid #EF4444', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                            {cargandoEsta ? '...' : t.cancelar}
                          </button>
                        </>
                      ) : (
                        <button onClick={() => inscribirse(clase.id)} disabled={sinCupos || cargandoEsta}
                          style={{ width:'100%', padding:'7px 0', background: sinCupos ? '#E2E6F0' : '#1B3A8C', color: sinCupos ? '#9CA3AF' : '#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:600, cursor: sinCupos ? 'not-allowed' : 'pointer' }}>
                          {cargandoEsta ? '...' : sinCupos ? t.sinCupos : t.inscribirme}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}

      {clasesFiltradas.length === 0 && (
        <div style={{ textAlign:'center', padding:60, color:'#6B7280' }}>
          <div style={{ fontSize:48, marginBottom:12 }}>📭</div>
          <p style={{ fontSize:16 }}>{t.vacio}</p>
        </div>
      )}

      <ModalPerfilProfesor clase={perfilProfesor} onCerrar={() => setPerfilProfesor(null)} t={t} />
    </div>
  )
}
